import formatDate from '@/filters/formatDate';

export default formalization => {
  const { blockNumber, blockCity, blockDate } = formalization;

  if(!blockNumber || !blockCity || !blockDate) return '';

  return `${blockNumber}-${blockCity} ${formatDate(blockDate, 'YYYY')}`
};
